import React from "react";
import {ChipLabel} from "./index";

const AdminTypeChip = ({superAdmin, marketing}) => {
    return (
        <ChipLabel
            label={marketing ? 'Marketing' : superAdmin ? 'Super Admin' : 'Admin'}
            className={`status-chip ${superAdmin ? 'primary' : 'secondary'}`}
        />
    )
}

export default AdminTypeChip;